import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "scroll !important",
    height: "100%",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  container: {
    marginTop: 70,
    padding: theme.spacing.space16,
  },
  disabled: {
    color: theme.colors.TextSilver,
  },
}));
